import { useLanguage } from './useLanguage'

export function useIsFR() {
    const language = useLanguage()
    return language === 'fr'
}
